import { FilterState } from "./ShowsNearbyFilters";
import { ListFilter } from "lucide-react";
import { cn } from "@/components/common/utils";

interface AllFiltersButtonProps {
  optimisticState: FilterState;
  onClick: () => void;
  disabled?: boolean;
}

export function AllFiltersButton({
  optimisticState,
  onClick,
  disabled = false,
}: AllFiltersButtonProps) {
  const enabledFiltersCount = Object.values(optimisticState).filter(
    // only count the filters that are not set to "all"
    (filter) => filter !== "all"
  ).length;

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "w-18 flex flex-row items-center gap-1 rounded-md px-3 py-2 text-sm font-medium transition-colors duration-200 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed",
        enabledFiltersCount > 0
          ? "bg-[#29333C] text-white font-medium"
          : "bg-gray-100 text-gray-500 hover:text-gray-700"
      )}
      disabled={disabled}
    >
      <ListFilter height={20} width={20} />({enabledFiltersCount})
    </button>
  );
}
